import { render } from "./ViewsProducts.vue?vue&type=template&id=93f75056"
import script from "./ViewsProducts.vue?vue&type=script&lang=js"
export * from "./ViewsProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__